<template>
  <div>
    <div class="espacio"></div>

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div v-if="mensajeDetalle"
               class="form-control is-invalid d-inline-block"
               style="width:auto">
            {{ mensajeDetalle }}
          </div>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Antecedentes">
  <AyudaAnteAten />
</Modal>

    <!-- Selector de tipo -->
    <select v-if="p_tipoAntecedente !== 'O'"
            class="form-select"
            v-model="tipoSeleccionado"
            @change="cargarDatos()">
      <option value="" disabled>Seleccione el tipo de antecedente</option>
      <option value="P">Antecedentes Personales</option>
      <option value="F">Antecedentes Familiares</option>
      <option value="Y">Otros Antecedentes Patológicos</option>
      <option v-if="p_tipoMotivoCita === 'O'" value="O">Antecedentes Obstétricos</option>
    </select>

    <hr>

    <!--  DataTable  -->
    <DataTable
      :data="anteatens"
      :columns="columnasActivas"
      idField="idAnteAten"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay antecedentes registrados."
      @refresh="cargarDatos()"
      @edit="({ idAnteAten }) => abrirModalEditar(idAnteAten)"
    >
      <!-- Botón de ayuda -->
      <template #boton-ayuda>
        <button
          class="btn-help"
          type="button"
          title="Abrir ayuda de antecedentes"
          @click="showModalHelp = true"
          aria-label="Abrir ayuda de antecedentes"
        >
          <span class="material-symbols-outlined">help</span>
        </button>
      </template>
    </DataTable>

    <!--  Modal editar antecedente  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalAnteAtenLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalAnteAtenLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Tipo -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Tipo</label></div>
                <div class="col-10">
                  <select class="form-control" v-model="datoAnteAten.tipo" disabled>
                    <option value="F">Antecedentes Familiares</option>
                    <option value="P">Antecedentes Personales</option>
                    <option value="Y">Otros Antecedentes Patológicos</option>
                    <option value="O">Antecedentes Obstétricos</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Antecedente -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Antecedente</label></div>
                <div class="col-10">
                  <select class="form-control" v-model="datoAnteAten.idAntecedente" disabled>
                    <option v-for="a in antecedentes"
                            :value="a.idAntecedente"
                            :key="a.idAntecedente">
                      {{ a.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Parentesco (solo tipo F) -->
            <div class="mb-3" v-if="datoAnteAten.tipo === 'F'">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Parentesco</label></div>
                <div class="col-3">
                  <select class="form-control" v-model="datoAnteAten.parentesco">
                    <option value="PADRE">Padre</option>
                    <option value="MADRE">Madre</option>
                    <option value="ABUELO PATERNO">Abuelo Paterno</option>
                    <option value="ABUELA PATERNA">Abuela Paterna</option>
                    <option value="ABUELO MATERNO">Abuelo Materno</option>
                    <option value="ABUELA MATERNA">Abuela Materna</option>
                    <option value="TIO PATERNO">Tío Paterno</option>
                    <option value="TIA PATERNA">Tía Paterna</option>
                    <option value="TIO MATERNO">Tío Materno</option>
                    <option value="TIA MATERNA">Tía Materna</option>
                  </select>
                </div>
                <!-- Botones rápidos de parentesco -->
                <div class="col-1" v-for="p in parentescosRapidos" :key="p.valor">
                  <button type="button" class="btn btn-light"
                          @click="datoAnteAten.parentesco = p.valor">
                    <i class="material-icons"
                       :style="`font-size:32px;color:${p.color};cursor:pointer`">
                      {{ p.icono }}
                    </i>
                    {{ p.label }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Respuesta (cantidad o sí/no) -->
            <div class="mb-3" v-if="datoAnteAten.tipoRespuesta > 0">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">
                    {{ datoAnteAten.tipoRespuesta == 1 ? 'Cantidad' : 'Seleccione' }}
                  </label>
                </div>
                <div class="col-10">
                  <input v-if="datoAnteAten.tipoRespuesta == 1"
                         type="number" class="form-control"
                         v-model="datoAnteAten.respuesta">
                  <select v-else class="form-control" v-model="datoAnteAten.respuesta">
                    <option value="S">Sí</option>
                    <option value="N">No</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Observación con micrófono -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Observación</label></div>
                <div class="col-10">
                  <div class="textarea-container-mic d-flex align-items-stretch">
                    <textarea class="form-control"
                              v-model="datoAnteAten.observacion"
                              style="text-transform:uppercase"
                              maxlength="250" required></textarea>
                    <div class="buttons-container-mic d-flex flex-column ms-2">
                      <button v-if="!isDictating" type="button"
                              class="btn btn-light" title="Iniciar Dictado"
                              @click="startDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                      </button>
                      <button v-else type="button"
                              class="btn btn-light" title="Finalizar Dictado"
                              @click="stopDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:green;cursor:pointer">mic</span>
                      </button>
                      <div class="flex-grow-1"></div>
                      <small class="text-muted mt-auto text-end">
                        {{ (datoAnteAten.observacion || '').length }} / 250
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button"
                    class="btn btn-light"
                    @click.prevent="guardarAnteAten()">
              <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">save</i>
            </button>
            <button v-if="btnEditar" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditAnteAten()">
              <span class="material-symbols-outlined align-middle" style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaAnteAten  from '@/views/ayuda/AyudaAnteAten.vue'
import DataTable      from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import SpeechDictation from '@/modules/microfono.js'
import api            from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal           from 'sweetalert'

export default {
  name: 'AnteAten',
  components: { AyudaAnteAten, DataTable },

  props: {
    p_idAtencion:      { type: Number, required: true },
    p_estadoAtencion:  { type: String, required: true },
    p_tipoMotivoCita:  { type: String, required: true },
    p_tipoAntecedente: { type: String, required: true },
  },

  data() {
    return {
      anteatens:       [],
      datoAnteAten:    {},
      titulo:          '',
      btnCrear:        false,
      btnEditar:       false,
      modalWindow:     true,
      antecedentes:    [],
      dictation:       new SpeechDictation(),
      isDictating:     false,
      mensajeDetalle:  '',
      showModalHelp:   false,
      tipoSeleccionado:'',

      // Botones rápidos de parentesco — evita repetición en el template
      parentescosRapidos: [
        { valor: 'PADRE',          label: 'Padre',          icono: 'man',           color: 'lightblue' },
        { valor: 'MADRE',          label: 'Madre',          icono: 'woman',         color: 'pink' },
        { valor: 'ABUELO PATERNO', label: 'Abuelo Paterno', icono: 'elderly',       color: 'lightblue' },
        { valor: 'ABUELA PATERNA', label: 'Abuela Paterna', icono: 'elderly_woman', color: 'pink' },
        { valor: 'ABUELO MATERNO', label: 'Abuelo Materno', icono: 'elderly',       color: 'lightblue' },
        { valor: 'ABUELA MATERNA', label: 'Abuela Materna', icono: 'elderly_woman', color: 'pink' },
      ],

      //  Columnas base
      columnas: [
        { field: 'antecedenteNombre', label: 'Descripción' },
        { field: 'parentesco',        label: 'Parentesco' },
        { field: 'cantidad',          label: 'Cantidad' },
        { field: 'observacion',       label: 'Observación' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    // Muestra columnas según el tipo seleccionado
    columnasActivas() {
      return this.columnas.filter(col => {
        if (col.field === 'parentesco') return this.tipoSeleccionado === 'F'
        if (col.field === 'cantidad')   return this.tipoSeleccionado === 'O'
        return true
      })
    },
  },

  mounted() {
    this.fetchAntecedentes()
    if (this.p_tipoAntecedente === 'O') {
      this.tipoSeleccionado = 'O'
      this.cargarDatos()
    }
  },

  methods: {
    //  Carga de datos
    cargarDatos() {
      if (!this.tipoSeleccionado) return
      api.get(`/vwanteatens/idatencion-tipo/${this.p_idAtencion}/${this.tipoSeleccionado}`)
        .then(response => { this.anteatens = response.data.reverse() })
        .catch(error   => console.error('Error cargando antecedentes:', error))
    },

    fetchAntecedentes() {
      api.get('/vwantecedentes')
        .then(response => { this.antecedentes = response.data })
        .catch(error   => console.error('Error fetching antecedentes:', error))
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoAnteAten,
        ['idAntecedente', 'observacion'],
        ['idAntecedente', 'observacion']
      )
    },

    //  CRUD
    async guardarAnteAten() {
      if (this.validarForm() !== 1) return
      try {
        this.datoAnteAten.idAtencion = this.p_idAtencion
        await api.post('/anteatens', this.datoAnteAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Antecedente creado exitosamente!', 'success')
        this.cargarDatos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditAnteAten() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/anteatens', this.datoAnteAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Antecedente actualizado exitosamente!', 'success')
        this.cargarDatos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    abrirModalEditar(idAnteAten) {
      if (!['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }
      this.modalWindow = true
      if (idAnteAten) {
        api.get(`/vwanteatens/${idAnteAten}`)
          .then(resp => { this.datoAnteAten = resp.data })
      }
      this.titulo    = 'Antecedentes'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },

    //  Micrófono
    startDictation() {
      this.isDictating = true
      this.dictation.startDictation(
        transcript => { this.datoAnteAten.observacion = transcript },
        this.datoAnteAten.observacion
      )
    },
    stopDictation() {
      this.isDictating = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/tabla_estilizada.css" scoped></style>
<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.espacio { margin-top: 0.25em; }
</style>